import React, { useRef } from 'react';
var VeltAutocompleteTool = function (props) {
    var hotkey = props.hotkey, componentMeta = props.componentMeta, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-tool", { ref: ref, hotkey: hotkey, "component-meta": componentMeta ? (typeof componentMeta === 'string' ? componentMeta : JSON.stringify(componentMeta)) : undefined, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltAutocompleteTool;
